<div class="stick-top">
  <mat-toolbar><mat-icon>work</mat-icon> Task Logs</mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <div class="fill-space"></div>
    <micro-date-range [(unit)]="usageFilter.dateRangeUnit" [(from)]="usageFilter.from" [(fromInfinite)]="usageFilter.fromInfinite" [(until)]="usageFilter.until" [(untilInfinite)]="usageFilter.untilInfinite" ></micro-date-range>
  </div>
</div>

<micro-do-chart [smallChart]="true" [doChartFilter]="usageFilter" dateField="datetime" entityType="TASK_LOG" filter="" groupBy="action"></micro-do-chart>

<table class="dataTable">
  <thead>
    <tr>
      <th class="guuidHeader">
        <div class="vbox">
          Id
          <input [(ngModel)]="filter.id">
        </div>
      </th>
      <th class="dateTimeHeader">
        <div class="vbox">
          Date
        </div>
      </th>
      <th style="width: 140px;">
        <div class="vbox" >
          Action
          <input [(ngModel)]="filter.action">
        </div>
      </th>
      <th style="width: 100px;">
        <div class="vbox">
          Task Carrier
          <micro-taskCarrier-select [(taskCarrierId)]="filter.taskCarrierId"></micro-taskCarrier-select>
        </div>
      </th>
      <th style="width: 100px;">
        <div class="vbox">
          User
          <micro-user-select [(userId)]="filter.userId"></micro-user-select>
        </div>
      </th>
      <th>
        <div class="vbox">
          Request
          <input [(ngModel)]="filter.req">
        </div>
      </th>
      <th>
        <div class="vbox">
          Response
          <input [(ngModel)]="filter.rsp">
        </div>
      </th>
      <th>
        <div class="vbox">
          Error
          <input [(ngModel)]="filter.error">
        </div>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let element of dataSource.data">
      <td [ngClass]="element.error ? 'CRITICAL' : ''" [matTooltip]="element.error"><a routerLink="/task/taskLogs/{{element.id}}">{{element.id}}</a></td>
      <td class="text-center">{{element.datetime | dateTimeMs}}</td>
      <td class="text-center">{{element.action}}</td>
      <td class="text-center"><micro-taskCarrier-lookup [taskCarrierId]="element.taskCarrierId"></micro-taskCarrier-lookup></td>
      <td><micro-user-lookup [userId]="element.userId"></micro-user-lookup></td>
      <td [matTooltip]="element.req">{{element.req}}</td>
      <td [matTooltip]="element.rsp">{{element.rsp}}</td>
      <td [matTooltip]="element.errorDetail">{{element.error}}</td>
    </tr>
  </tbody>
</table>

<mat-paginator #paginator
               (page)="reload()"
               [pageSize]="10"
               [pageSizeOptions]="[5, 10, 20, 50, 100, 500]">
</mat-paginator>
